import { Input, OnDestroy, Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';

import { Subscription } from 'rxjs';

import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { ChartFieldModel } from '../../../models/chart-field.model';
import { ButtonTypesEnum } from '../../../../Forms/enums/button-types.enum';
import { RadioTypesEnum } from '../../../../Forms/enums/radio-types.enum';
import { BlockFormComponent } from '../../BlockForm/block-form.component';
import { AbstractPageBuilderService } from '../../../services/abstract-page-builder.service';
import { BriefingChartDisplayElementModel } from '../../../../../Common/PageBuilder/models/briefing-chart-display-element.model';
import { ChartDisplayElementModel } from '../../../../../Common/Reports/models/chart-display-element.model';
import { messageSeverityEnum } from '../../../../../Common/Misc/enums/message-severity.enum';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { ConfirmDialogComponent } from '../../../../Dialogs/components/ConfirmDialog/confirm-dialog.component';


@Component({
    selector: 'agpr-chart-field',
    templateUrl: './chart-field.component.html',
    styleUrls: ['./chart-field.component.scss'],
    standalone: false
})
export class ChartFieldComponent extends AbstractFormFieldComponent implements OnInit, OnDestroy {
    readonly buttonTypes = ButtonTypesEnum;
    readonly radioTypesEnum = RadioTypesEnum;

    @ViewChild('formFieldsContainer', { read: ViewContainerRef }) fieldsContainer: ViewContainerRef;
    @Input() declare field: ChartFieldModel;

    id: string = 'ChartField';

    overlayContainer: Element;
    resourceDeleted: boolean;
    subscriptions: Subscription[] = [];

    readonly messageSeverities = messageSeverityEnum;

    constructor(
        private blockForm: BlockFormComponent,
        private pageBuilderService: AbstractPageBuilderService,
        private coreDialogService: CoreDialogService,
    ) {
        super();
        this.overlayContainer = document.getElementById('main-content');
    }
    ngOnInit(): void {
        this.createFields();
        this.subscriptions.push(
            this.pageBuilderService.getBlockNoData().subscribe(series => {
                const chartBlock = (this.block?.displayElement as BriefingChartDisplayElementModel)?.chartBlock;
                if (chartBlock && (chartBlock.displayElement as ChartDisplayElementModel)?.series.find(x => series.includes(x))) {
                    this.resourceDeleted = true;
                } else {
                    this.resourceDeleted = false;
                }
            })
        );
    }

    openChartDialog(): void {
        this.pageBuilderService.updateChart(this.block);
    }

    createFields() {
        this.field.fields.forEach((field, i) => {
            this.blockForm.createField(field, this.id + '_' + i, this.fieldsContainer);
        });
    }

    generationMethodChanged(value: boolean): void {
        if (!value) {
            this.pageBuilderService.refreshBlockData(this.block);
            (this.block.displayElement as BriefingChartDisplayElementModel).chart.refreshed = true;
        }
        this.changes.emit(this.value);
    }

    refreshData(): void {
        this.coreDialogService.open(
            ConfirmDialogComponent,
            {
                inputs: {
                    heading: 'PageBuilder.blockType.chart.refreshChartData.confirmation.heading',
                    messageHtml: 'PageBuilder.blockType.chart.refreshChartData.confirmation.Message',
                    okLabel: 'PageBuilder.blockType.chart.refreshChartData.confirmation.confirm',
                    cancelLabel: 'cancel'
                },
                outputs: {
                    dialogClose: (confirmed: boolean) => {
                        if (confirmed) {
                            this.pageBuilderService.refreshBlockData(this.block);
                            (this.block.displayElement as BriefingChartDisplayElementModel).chart.refreshed = true;
                        }
                    }
                }
            }
        );
    }

    ngOnDestroy(): void {
        this.subscriptions?.forEach(sub => sub.unsubscribe());
    }
}
